<!-- src/app/components/token-management/token-management.component.html -->
<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-bullhorn"></span>Token Management</div>
  </div>

  <div class="content">

    <div class="row justify-content-between">
      <div class="col-3">
        <div class="p-inputgroup">
          <input type="text" pInputText placeholder="Partner ID" name="Partner ID"
                 [(ngModel)]="partnerId"/>
          <button class="iso-round-button iso-secondary ml-2" (click)="loadTokens()">Search</button>
        </div>
      </div>
      <div class="col-3 d-flex justify-content-end">
        <button class="iso-round-button iso-secondary mb-3" (click)="openCreateTokenModal()">Create New Token</button>
      </div>

    </div>


    <table class="table table-striped">
      <thead>
      <tr>
        <th>Name</th>
        <th>Token ID</th>
        <th>Partner Parent ID</th>
        <th>Expiry</th>
        <th>Revoked Status</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let token of tokens">
        <td>{{ token.name }}</td>
        <td>{{ token.tokenId }}</td>
        <td>{{ token.partnerParentId }}</td>
        <td>{{ token.expiry | date: 'medium' }}</td>
        <td>{{ token.isRevoked ? 'Revoked' : 'Active' }}</td>
        <td>
          <button class="iso-round-button iso-secondary mr-1" (click)="openViewTokenModal(token)">View Token</button>
          <button class="iso-round-button" (click)="openRevokeTokenModal(token.tokenId)" [disabled]="token.isRevoked">
            Revoke Token
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</div>
